<mat-card
    class="mb-25 tagus-card add-user-wrapper coventry-form position-relative"
>
    <mat-card-header>
        <h3 class="py-4 px-4">
            <strong>
                Hello, my name is {{ user_details?.name }}, I will be conducting
                your Final/Mock interview today. Can you please show me your
                passport?
            </strong>
        </h3>
    </mat-card-header>

    <mat-card-content>
        <form [formGroup]="interviewForm" (ngSubmit)="onSubmit()">
            <div formArrayName="radioQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('radioQuestions')
                            .controls;
                        let i = index
                    "
                    [formGroupName]="i"
                >
                    <div class="row fw-semibold pb-5">
                        <label class="col-sm-4 label-center">
                            {{ radioQuestionArr[i].question }}
                            <b
                                class="color-red"
                                *ngIf="radioQuestionArr[i]?.isRequired"
                                >*</b
                            >
                        </label>
                        <div class="col-sm-6">
                            <div class="d-flex gap-x-2">
                                <ng-container
                                    *ngFor="
                                        let option of radioQuestionArr[i]
                                            .options
                                    "
                                >
                                    <input
                                        type="radio"
                                        [id]="option?.id"
                                        [value]="option?.value"
                                        formControlName="answer"
                                        (change)="onChanges(group, i)"
                                    />
                                    <label
                                        [for]="option?.id"
                                        class="cursor-pointer"
                                    >
                                        {{ option?.label }}
                                    </label>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <ng-container
                        formArrayName="subQuestions"
                        *ngIf="group.get('subQuestions').controls.length > 0"
                    >
                        <div class="row border pb-10 mb-15">
                            <div
                                class="col-sm-12 px-4 py-4 bg-blue text-white fw-semibold fs-14"
                            >
                                {{ radioQuestionArr[i].subQuestionLabel.label }}
                            </div>
                            <div
                                *ngFor="
                                    let subGroup of group.get('subQuestions')
                                        .controls;
                                    let j = index
                                "
                                [formGroupName]="j"
                                class="row fw-semibold pb-5 mb-5 py-2"
                            >
                                <div class="col-sm-4 label-center">
                                    {{ j + 1 }}.
                                    {{
                                        radioQuestionArr[i].subQuestions[j]
                                            .question
                                    }}
                                    <b
                                        class="color-red"
                                        *ngIf="
                                            radioQuestionArr[i].subQuestions[j]
                                                ?.isRequired
                                        "
                                        >*</b
                                    >
                                </div>
                                <div class="col-sm-8">
                                    <div class="d-flex gap-x-2">
                                        <ng-container
                                            *ngFor="
                                                let subOption of radioQuestionArr[
                                                    i
                                                ].subQuestions[j].options
                                            "
                                        >
                                            <input
                                                type="radio"
                                                [id]="subOption?.id"
                                                [value]="subOption?.value"
                                                formControlName="answer"
                                            />
                                            <label
                                                [for]="subOption?.id"
                                                class="cursor-pointer"
                                            >
                                                {{ subOption?.label }}
                                            </label>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div formArrayName="interviewQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('interviewQuestions')
                            .controls;
                        let i = index
                    "
                >
                    <div class="row mt-15">
                        <div
                            class="col-sm-12 py-4 bg-blue text-white fw-semibold fs-20"
                        >
                            {{ interviewQuestions[i].primary.heading }}
                        </div>
                    </div>

                    <div class="row bg-grey">
                        <div class="col-sm-3">
                            <div class="row">
                                <div class="col-sm-2 border py-4"></div>
                                <div class="col-sm-10 border py-4">
                                    <b>Question</b>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2 border py-4">
                            <b>Key Responses</b>
                        </div>
                        <div class="col-sm-2 border py-4"><b>Concerns</b></div>
                        <div class="col-sm-3 border py-4"><b>Comments</b></div>
                        <div class="col-sm-2">
                            <div class="row">
                                <div class="col-sm-4 border py-4">
                                    <b> R </b>
                                </div>
                                <div class="col-sm-4 border py-4">
                                    <b> A </b>
                                </div>
                                <div class="col-sm-4 border py-4">
                                    <b> G </b>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div [formGroupName]="i">
                        <div formArrayName="interviewQuestionList">
                            <div
                                *ngFor="
                                    let item of group.get(
                                        'interviewQuestionList'
                                    ).controls;
                                    let k = index
                                "
                                [formGroupName]="k"
                                class="row"
                            >
                                <ng-container
                                    *ngIf="
                                        interviewQuestions[i].questionList[k]
                                            ?.label
                                    "
                                >
                                    <div class="col-sm-12 py-4 h-100 border">
                                        <span
                                            *ngIf="
                                                interviewQuestions[i]
                                                    .questionList[k]?.label
                                            "
                                        >
                                            {{
                                                interviewQuestions[i]
                                                    .questionList[k].questionNo
                                            }}).
                                        </span>

                                        <span
                                            class="ps-15 fs-16 fw-semibold"
                                            style="color: red"
                                            >{{
                                                interviewQuestions[i]
                                                    .questionList[k]?.label
                                            }}</span
                                        >
                                    </div>
                                </ng-container>
                                <div class="col-sm-3">
                                    <div class="row h-100">
                                        <div class="col-sm-2 h-100 py-4 border">
                                            <ng-container
                                                *ngIf="
                                                    !interviewQuestions[i]
                                                        .questionList[k]?.label
                                                "
                                            >
                                                {{
                                                    interviewQuestions[i]
                                                        .questionList[k]
                                                        .questionNo
                                                }}).
                                            </ng-container>
                                        </div>
                                        <div class="col-sm-10 py-4 border">
                                            {{
                                                interviewQuestions[i]
                                                    .questionList[k].question
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <ng-container>
                                    <ng-container formArrayName="subQuestions">
                                        <div
                                            class="col-sm-2 p-0 ps-5 pe-5 pt-5 border py-4 justify-content-space-between border-b"
                                            *ngFor="
                                                let subQuestionGroup of item.get(
                                                    'subQuestions'
                                                ).controls;
                                                let subIndex = index
                                            "
                                            [formArrayName]="subIndex"
                                        >
                                            <div
                                                *ngFor="
                                                    let sq of subQuestionGroup.controls;
                                                    let sqIndex = index
                                                "
                                                [formGroupName]="sqIndex"
                                                class="mb-10 d-flex gap-x-2"
                                            >
                                                <p
                                                    class="leading-tight text-black fs-14"
                                                    [innerHTML]="
                                                        sq.get('question').value
                                                    "
                                                    style="max-width: 100px"
                                                ></p>
                                                <div
                                                    *ngFor="
                                                        let subRadio of interviewQuestions[
                                                            i
                                                        ].questionList[k]
                                                            .subQuestions[
                                                            subIndex
                                                        ][sqIndex].options;
                                                        let subRadioIndex = index
                                                    "
                                                >
                                                    <input
                                                        type="radio"
                                                        [value]="
                                                            subRadio?.value
                                                        "
                                                        id="sub_{{ k }}_{{
                                                            sqIndex
                                                        }}_{{
                                                            subRadioIndex
                                                        }}_{{ subIndex }}"
                                                        formControlName="answer"
                                                    />
                                                    <label
                                                        htmlFor="sub_{{ k }}_{{
                                                            sqIndex
                                                        }}_{{
                                                            subRadioIndex
                                                        }}_{{ subIndex }}"
                                                        >{{
                                                            subRadio?.label
                                                        }}</label
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <div class="col-sm-3 border py-4">
                                    <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                    >
                                        <mat-label>Leave a comment</mat-label>
                                        <textarea
                                            rows="5"
                                            matInput
                                            formControlName="answer"
                                            placeholder="Add comment....."
                                        ></textarea>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-2">
                                    <div class="row h-100">
                                        <div
                                            class="col-sm-4 border p-0 ps-5"
                                            *ngFor="
                                                let decision of interviewQuestions[0]
                                                    ?.primary?.decisions;
                                                index as decisionIndex
                                            "
                                        >
                                            <label
                                                htmlFor="decision_${{ i }}_${{
                                                    k
                                                }}_{{ decisionIndex }}"
                                                >{{ decision?.label }}</label
                                            >
                                            <input
                                                type="radio"
                                                id="decision_${{ i }}_${{
                                                    k
                                                }}_{{ decisionIndex }}"
                                                [value]="decision?.value"
                                                formControlName="decision"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-10 py-4" formArrayName="decisionQuestions">
                <div
                    class="col-sm-12 px-4 py-4 bg-blue text-white fw-semibold fs-20"
                >
                    {{ decisionQuestionArr[0].primary.heading }}
                </div>
                <div
                    *ngFor="
                        let group of interviewForm.get('decisionQuestions')
                            .controls;
                        let m = index
                    "
                    [formGroupName]="m"
                >
                    <div class="row fw-semibold pb-5 py-4">
                        <label class="col-sm-4 label-center">
                            {{ decisionQuestionArr[0]?.questions[m]?.question }}
                            <b
                                class="color-red"
                                *ngIf="
                                    decisionQuestionArr[0]?.questions[m]
                                        ?.isRequired
                                "
                                >*</b
                            >
                        </label>
                        <div class="col-sm-6">
                            <div class="d-flex gap-x-2">
                                <ng-container
                                    *ngFor="
                                        let option of decisionQuestionArr[0]
                                            ?.questions[m].options
                                    "
                                >
                                    <input
                                        type="radio"
                                        [id]="option?.id"
                                        [value]="option?.value"
                                        formControlName="answer"
                                    />
                                    <label
                                        [for]="option?.id"
                                        class="cursor-pointer"
                                    >
                                        {{ option?.label }}
                                    </label>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div formArrayName="additionalQuestions">
                <div
                    *ngFor="
                        let group of interviewForm.get('additionalQuestions')
                            .controls;
                        let i = index
                    "
                >
                    <div [formGroupName]="i">
                        <div class="row" formArrayName="additionalQuestionList">
                            <ng-container
                                *ngFor="
                                    let item of group.get(
                                        'additionalQuestionList'
                                    ).controls;
                                    let k = index
                                "
                                [formGroupName]="k"
                            >
                                <div class="col-sm-3">
                                    <span
                                        [innerHTML]="
                                            additionalQuestions[i].questionList[
                                                k
                                            ].question
                                        "
                                    ></span>

                                    <ng-container
                                        *ngIf="
                                            additionalQuestions[i].questionList[
                                                k
                                            ].answerType === 'checkbox'
                                        "
                                    >
                                        <mat-radio-group
                                            formControlName="answer"
                                        >
                                            <ng-container
                                                *ngFor="
                                                    let option of additionalQuestions[
                                                        i
                                                    ].questionList[k]?.options
                                                "
                                            >
                                                <mat-radio-button
                                                    class="cursor-pointer"
                                                    [value]="option?.id"
                                                >
                                                    {{ option?.value }}
                                                </mat-radio-button>
                                            </ng-container>
                                        </mat-radio-group>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="
                                            additionalQuestions[i].questionList[
                                                k
                                            ].answerType === 'textarea'
                                        "
                                    >
                                        <mat-form-field
                                            class="w-100 mt-10"
                                            appearance="outline"
                                        >
                                            <textarea
                                                matInput
                                                formControlName="answer"
                                            ></textarea>
                                        </mat-form-field>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="
                                            additionalQuestions[i].questionList[
                                                k
                                            ].answerType === 'input'
                                        "
                                    >
                                        <mat-form-field
                                            class="w-100 pt-10"
                                            appearance="outline"
                                        >
                                            <mat-label>Answer</mat-label>
                                            <input
                                                matInput
                                                formControlName="answer"
                                            />
                                        </mat-form-field>
                                    </ng-container>
                                </div> <br/>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <button type="submit">Submit</button> -->
        </form>
    </mat-card-content>
</mat-card>
